import { combineReducers } from "redux";
import globalReducer from "./Global/reducer";
import authReducer from "./authentication/reducer";
import dealerReducer from "./dealers/reducer";
import branchReducer from "./branch/reducer";
import userReducer from "./user/reducer";
import ridesReducer from "./rides/reducer";
import labelAndPlaceholderReducers from "./labelAndPlaceHolder/reducer";
import eventReducers from "./event/reducer";
import vinLookupReducer from "./VinLookup/reducer";
import reportsReducer from "./reports/reducer";
import statisticsReducer from "./Statistics/reducer";
import toursReducer from "./moderation/tours/reducer";
import partnersReducer from "./partners/reducer";
import experienceReducer from "./moderation/experience/reducer";
import testimonialReducer from "./Testimonials/reducer";
import uploadImageReducer from "./uploadImage/reducer";
export default combineReducers({
  Global: globalReducer,
  Auth: authReducer,
  Dealer: dealerReducer,
  Branch: branchReducer,
  User: userReducer,
  Ride: ridesReducer,
  Elements: labelAndPlaceholderReducers,
  Events: eventReducers,
  VinLookup: vinLookupReducer,
  Reports: reportsReducer,
  Tours: toursReducer,
  Experience: experienceReducer,
  statistics: statisticsReducer,
  Partner: partnersReducer,
  Testimonials: testimonialReducer,
  UploadImage: uploadImageReducer,
});
